// src/config/plotConfigs/differentialSilhouetteConfig.js
export const differentialSilhouetteConfig = {
  sections: [
    {
      fields: [
        {
          id: "geneType",
          label: "Gene Type",
          type: "radio",
          options: [
            { value: "all", label: "All" },
            { value: "coding", label: "Coding" },
            { value: "noncoding", label: "Non-coding" },
          ],
          tooltip:
            "Carry out the search using coding transcripts (default), non-coding transcripts or all transcripts.",
          width: 12,
        },
        {
          id: "region",
          label: "Region",
          type: "radio",
          options: [
            { value: "region_entire_tran", label: "Entire transcript" },
            { value: "region_cds_only", label: "CDS only" },
          ],
          tooltip:
            "Carry out the search across the entire transcript or limit to the CDS. If set to CDS Gene type should be set to coding.",
          width: 12,
        },
        {
          id: "minReadLength",
          label: "Min Read Length",
          type: "number",
          placeholder: "20",
          min: 1,
          max: 1000,
          tooltip:
            "The minimum ribo-seq read length used to create profiles and carry out the differential silhouette analysis.",
          width: 6,
        },
        {
          id: "maxReadLength",
          label: "Max Read Length",
          type: "number",
          placeholder: "150",
          min: 1,
          max: 1000,
          tooltip:
            "The maximum ribo-seq read length used to create profiles and carry out the differential silhouette analysis.",
          width: 6,
        },
        {
          id: "ambiguousReads",
          label: "Allow ambiguously mapped reads",
          type: "checkbox",
          tooltip:
            "Checking this box means that both ambiguously mapped reads and unambiguously mapped reads will be displayed. A read is considered ambiguous if it maps to 2 or 3 different genes. Ambiguous reads are weighted according to the number of genes they align to, reads that align to two genes have a count of 0.5 while reads that align to 3 genes have a count of 0.33.",
          width: 12,
          advanced: true,
        },
        {
          id: "dCorrMin",
          label: "D-Corr Within Replicate Min",
          type: "number",
          placeholder: "Optional",
          tooltip: "Minimum D-Corr within replicates (optional)",
          width: 6,
          advanced: true,
        },
        {
          id: "dMaxThreshold",
          label: "D-Max Threshold",
          type: "number",
          placeholder: "Optional",
          tooltip:
            "Threshold used for D-max when 'Both' plot type is selected.",
          width: 6,
          advanced: true,
        },
        {
          id: "dCorrThreshold",
          label: "D-Corr Threshold",
          type: "number",
          placeholder: "Optional",
          tooltip:
            "Threshold used for D-corr when 'Both' plot type is selected.",
          width: 6,
          advanced: true,
        },
        {
          id: "emailNotification",
          label: "Email notification",
          type: "checkbox",
          tooltip:
            "If checked an email notification will be sent to you once the job has completed. The email will contain a link to the results of this job.",
          width: 6,
        },
      ],
    },
  ],
};

export const differentialSilhouetteDefaults = {
  plotType: "both",
  geneType: "coding",
  region: "region_entire_tran",
  minReadLength: 20,
  maxReadLength: 35,
  dMaxThreshold: "8",
  dCorrThreshold: "0.15",
  dCorrMin: "",
  ambiguousReads: false,
  emailNotification: false,
};

export const differentialSilhouetteValidation = {
  plotType: { required: true, label: "Plot Type" },
  geneType: { required: true, label: "Gene Type" },
  region: { required: true, label: "Region" },
  minReadLength: {
    required: true,
    min: 1,
    max: 1000,
    label: "Min Read Length",
  },
  maxReadLength: {
    required: true,
    min: 1,
    max: 1000,
    label: "Max Read Length",
  },
  custom: (value, allSettings) => {
    if (allSettings.minReadLength >= allSettings.maxReadLength) {
      return "Min read length must be less than max read length";
    }
    return null;
  },
};
